import Navigation from "@/components/Navigation";
import HeroSlider from "@/components/HeroSlider";
import WelcomeSection from "@/components/WelcomeSection";
import LocationSection from "@/components/LocationSection";
import GalleryCarousel from "@/components/GalleryCarousel";
import BookingForm from "@/components/BookingForm";
import BookSection from "@/components/BookSection";
import Footer from "@/components/Footer";
import { AIChatbot } from "@/components/AIChatbot";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <HeroSlider />
      <WelcomeSection />
      <LocationSection />
      <GalleryCarousel />
      <BookingForm />
      <BookSection />
      <Footer />
      <AIChatbot />
    </div>
  );
};

export default Index;
